import {RABBIT_SERVERS_URL} from '../config';
// import * as SockJS from 'sockjs-client';
import * as ng from 'angular';
import * as Stomp from '@stomp/stompjs';

class RabbitMQ {
  STATE: number = 0;
  DEAD: number = 0;
  client: any = null;
  private rabbitMQInstanceIndex: number = -1;
  private user: string = '';
  private password: string = '';
  private $rootScope: any = undefined;

  init(_user: any, _password: any, _testEnvironment: any) {
    if (this.STATE === 0) {
      this.user = _user === undefined ? this.user : _user;
      this.password = _password === undefined ? this.password : _password;

      this.rabbitMQInstanceIndex++;
      var servers = RABBIT_SERVERS_URL;

      var server = servers[this.rabbitMQInstanceIndex % servers.length];
      // let ws = new SockJS(server);

      // this.client = Stomp.over(ws);
      this.client = Stomp.client(server);
      this.client.debug = null;

      // sockJS does not support heart-beat: disable heart-beats
      // if (location.search !== '?ws') {
      //     this.client.heartbeat.outgoing = 0;
      //     this.client.heartbeat.incoming = 0;
      // }

      // heartbeats to server in ms
      this.client.heartbeat.outgoing = 30000;
      // heartbeats from server in ms
      this.client.heartbeat.incoming = 0;
      // reconnect after 5000ms
      this.client.reconnect_delay = 5000;

      this.client.connect(this.user, this.password, this.on_connect.bind(this), this.on_error.bind(this), '/');
    } else {
      let scope: any = ng.element($('html')).scope();
      scope.startNotificationWorker();
    }
  }

  on_connect(x: any) {
    this.client.STATE = 1;
    if (this.DEAD === 1) {
      this.$rootScope = ng.element($('html')).injector().get('$rootScope');
      let _scope: any = ng.element(document.getElementsByTagName('html')).scope();
      if (this.$rootScope.subscriptionNotificationWorker !== undefined) {
        _scope.safeApply(() => {
          this.$rootScope.subscriptionNotificationWorker = undefined;
        });
      }
      this.DEAD = 0;
      let scope: any = ng.element($('html')).scope();
      scope.startNotificationWorker();
    }
    this.rabbitMQInstanceIndex--;
  }

  on_error(msg: any) {
    this.client.STATE = 0;
    this.DEAD = 1;
  }

  send(queue: any, data: any, audit?: any) {
    this.client.send(queue, {'content-type': 'application/json'}, data);

    if (this.$rootScope === undefined) {
      // get angular  $rootScope
      let $body = ng.element(document.body);
      this.$rootScope = $body.scope().$root;
    }

    if (audit) {
      let settings = {
        'auditType': 3,
        'workerName': queue,
        'workerMessage': data,
      };
      this.$rootScope.audit(settings);
    }
  }
}

export const rabbitMQ: RabbitMQ = new RabbitMQ();



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/third/rabbitMQ.ts